import { Button } from 'src/components/Button/Button.component';
import { ButtonContainer } from 'src/components/Button/style/Button.style';
import Loader from 'src/components/Loader/Loader.component';
import PayByLinkHeader from 'src/components/PayByLinkHeader/PayByLinkHeader.component';
import SelectCountry from 'src/components/SelectCountry/SelectCountry.component';
import Translate from 'src/components/Translate/Translate.component';
import { Privacy } from 'src/pages/registration/registrationMerchant/style/registrationMerchant.style';
import { FormProvider, useForm } from 'react-hook-form';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { RoutePath } from 'src/routers/routers.config';
import { isItalian } from 'src/services/i18n/i18n.helpers';
import { getCompanySearchCriteriaMethodApi } from 'src/services/orderLink/orderLink.request';
import { useRegistrationStore } from 'src/store/store';
import { H4 } from 'src/style-utils/typographic';
import { FlowContainer } from 'src/style/Container.style';
import { StyleSheetManager } from 'styled-components';
import { shouldForwardProp } from 'src/style-utils/functions';

function RegistrationStepCountry() {
  const navigate = useNavigate();
  const setValue = useRegistrationStore((state) => state.setValue);
  const country = useRegistrationStore((state) => state.country);
  const methods = useForm({
    defaultValues: {
      country: country?.length > 0 ? country.toUpperCase() : 'IT',
    },
    mode: 'onChange',
  });
  const { mutate, isPending } = useMutation({
    mutationFn: getCompanySearchCriteriaMethodApi,
    onSuccess: (res) => {
      const { country, name, vatNumber, postalCode } = res.data.ResultSet;
      const vatPrefix = res.data.ResultSet?.vatPrefix;
      setValue('country', country);
      setValue('validation', { name, vatNumber, postalCode, vatPrefix });
      setValue('codiceFiscale', '');
      setValue('postalCode', '');
      setValue('name', '');
      setValue('results', []);

      if (vatNumber.isAvailable) {
        navigate(RoutePath.registrationMerchant + RoutePath.stepVAT);
        return;
      }
      if (postalCode.isAvailable) {
        navigate(RoutePath.registrationMerchant + RoutePath.stepNamePostalCode);
        return;
      }
      navigate(RoutePath.registrationMerchant + RoutePath.stepName);
    },
  });

  if (isPending) {
    return <Loader overlayViewMode="fullscreen" active viewMode="fluid" />;
  }
  const onSubmit = (data: any) => {
    if (!isItalian(data['country'])) {
      mutate({ country: data['country'] });
      return;
    }
    navigate(RoutePath.registrationMerchant + RoutePath.fiscalCodeStep);
  };
  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      <PayByLinkHeader
        stepBack
        step={1}
        stepMax={9}
        title="lbl.companyNationality"
      />
      <FlowContainer>
        <H4 light>
          <Translate id="text.companyNationality" />
        </H4>
        <div className="content">
          <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit)}>
              <SelectCountry />
              <ButtonContainer>
                <Button i18n translatedText="lbl.next" />
                <Privacy>
                  <Translate
                    id="link.privacyLink"
                    extraTranslationProps={{
                      components: { u: <a /> },
                    }}
                  />
                </Privacy>
              </ButtonContainer>
            </form>
          </FormProvider>
        </div>
      </FlowContainer>
    </StyleSheetManager>
  );
}

export default RegistrationStepCountry;
